<div class="msg-screen">

  <!-- ══ LISTE DES THREADS ══ -->
  @if (!selectedThread()) {

    <div class="list-header">
      <p class="list-title">{{ 'mobileSimulator.message.listTitle' | translate }}</p>
      <span class="list-count">{{ 'mobileSimulator.message.channelsCount' | translate: { count: threads.length } }}</span>
    </div>

    <div class="thread-list">
      @for (thread of threads; track thread.id) {
        <button class="thread-item" (click)="selectThread(thread)">

          <div class="thread-avatar" [attr.data-status]="thread.status">
            {{ thread.title[0] }}
          </div>

          <div class="thread-info">
            <div class="thread-top">
              <span class="thread-name" [class.thread-name--unread]="thread.unread > 0">{{ thread.title }}</span>
              <span class="thread-time" [class.thread-time--unread]="thread.unread > 0">{{ thread.lastTime }}</span>
            </div>
            <span class="thread-sub">{{ thread.subtitle }}</span>
            <span class="thread-last" [class.thread-last--unread]="thread.unread > 0">{{ thread.lastMessage }}</span>
          </div>

          @if (thread.unread > 0) {
            <span class="thread-unread">{{ thread.unread }}</span>
          }

        </button>
      }
    </div>

  }

  <!-- ══ VUE DÉTAIL THREAD ══ -->
  @if (selectedThread(); as thread) {

    <div class="channel-header" [attr.data-status]="thread.status">
      <button class="back-btn" (click)="back()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
        </svg>
      </button>
      <div class="ch-avatar" [attr.data-status]="thread.status">{{ thread.title[0] }}</div>
      <div class="ch-body">
        <span class="ch-title">{{ thread.title }}</span>
        <p class="ch-sub">
          <span class="ch-dot" [attr.data-status]="thread.status"></span>
          {{ thread.subtitle }}
        </p>
      </div>
    </div>

    @if (thread.status === 'critique') {
      <div class="crisis-pin">
        <div class="pin-icon-wrap">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="#DC2626">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
          </svg>
        </div>
        <div class="pin-body">
          <span class="pin-label">{{ 'mobileSimulator.message.activeSituationLabel' | translate }}</span>
          <span class="pin-desc">
            {{ thread.title }}
            @if (thread.presenceEstimee != null) {
              · {{ thread.presenceEstimee }} {{ 'mobileSimulator.message.patientsUnit' | translate }}
            } @else {
              · 38 {{ 'mobileSimulator.message.patientsUnit' | translate }}
            }
            @if (thread.tensionMinutes != null) {
              · {{ 'mobileSimulator.common.since' | translate }} {{ thread.tensionMinutes }} min
            } @else {
              · {{ 'mobileSimulator.common.since' | translate }} 21 min
            }
          </span>
        </div>
      </div>
    }

    <div class="messages">

      <div class="date-sep"><span>{{ 'mobileSimulator.common.aujourdHui' | translate }}</span></div>

      @for (msg of currentMessages(); track msg.id) {

        @if (msg.type === 'system') {
          <div class="msg-system" [class.msg-system--alert]="msg.isAlert">
            <span class="sys-pill">{{ msg.time }} · {{ msg.text }}</span>
          </div>
        }

        @if (msg.type === 'received') {
          <div class="msg-row msg-row--received">
            <div class="msg-avatar" [ngStyle]="avatarStyle(msg.sender!)">{{ msg.sender![0] }}</div>
            <div class="msg-content">
              <span class="msg-meta">{{ msg.sender }} <span class="msg-meta-site">· {{ msg.site }}</span></span>
              <div class="msg-bubble msg-bubble--received">{{ msg.text }}</div>
              <span class="msg-time">{{ msg.time }}</span>
            </div>
          </div>
        }

        @if (msg.type === 'sent') {
          <div class="msg-row msg-row--sent">
            <div class="msg-content msg-content--sent">
              <div class="msg-bubble msg-bubble--sent">{{ msg.text }}</div>
              <span class="msg-time msg-time--sent">{{ msg.time }}</span>
            </div>
          </div>
        }

      }
    </div>

    <div class="input-bar">
      <div class="input-wrap">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="#C4C4D4">
          <path d="M19 3H4.99C3.89 3 3 3.9 3 5L3.01 19c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm7 13H5v-.23c0-.62.28-1.2.76-1.58C7.47 15.82 9.64 15 12 15s4.53.82 6.24 2.19c.48.38.76.97.76 1.58V19z"/>
        </svg>
        <span class="input-placeholder">{{ 'mobileSimulator.message.inputPlaceholder' | translate }}</span>
      </div>
      <button class="send-btn">
        <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
          <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
        </svg>
      </button>
    </div>

  }

</div>